// removed by extract-text-webpack-plugin
module.exports = {"even":"_2FGSQOeE--RgsH-NKT3ffh","eventDetailsWrapper":"_1ru7An_vaY7sz3KU7O6sk6","winPlaceShow":"_1Qf75CfHDhq3rx8_aZ3ruK","winPlaceShowContainer":"Fr0ABOxXcohTrbENb6xGB","eventDetails":"_3oCIhZ-EEF9ySL0vvYYxCl","eventDetailsCompetitor":"_1MXCVuL5vfxAC-GoAS9eIF","eventDetailsCompetitorNumNameContainer":"_3WvD-Dkmi24bKMDz8_IcuE","eventDetailsCompetitorNum":"_3LsT1WQmMnjsUOBJ4NJKFD","eventDetailsCompetitorName":"_2k5bqEEK_-FNqz8PqbMEZo","eventDetailsCompetitorPrice":"LgwasA3VKO7K99Gjfbun5","paddingLeft":"t5jmHblxr3YKA8V8Kf2KI","position":"_2ID0oEHOdC5HOZc6rua-Hg"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/lockedBetRacing.css
// module id = 733
// module chunks = 0